module.exports = __webpack_public_path__ + "assets/sentiment_positive_white.57ddb25c.svg";